// extracted by mini-css-extract-plugin
export default {"container":"overview_container__v5-7w","leftPanel":"overview_leftPanel__7M6nK","content":"overview_content__UqKcE"};